// Author: Shubham Srivastava
// Env File to use for Production.

export const environment = {
  production: true,
  configType: false,
  apiBaseUrl:'https://twwc-stage-a7030733ae78.herokuapp.com/v2',
  loginAPIUrl: 'https://twwc-stage-a7030733ae78.herokuapp.com/api/v1.0',
  apiBaseUrl2:'https://xabits.com/app',
  pgAPIUrl:'https://dev-ob1epin.herokuapp.com/api',
  setHeaderToken:true
};
